import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PostList from '../components/PostList';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <main style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <header style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2.5rem', color: '#333' }}>
          Welcome to SyntexHub Blog
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#666' }}>
          Discover posts, insights, and stories from our community.
        </p>
      </header>

      <section>
        <PostList />
      </section>
    </main>
  );
}
